import { isEmpty } from "lodash";
import React from "react";
import ReactSelect from "react-select";
import { Col, Input, Label, Row, TabPane } from "reactstrap";

export default function MedicalLicenses({
  subTabMedicalLicenses,
  onChange,
  appointmentId,
  pageEdit,
  isPageModalHistory,
  patientId,
}) {
  const { optionsMedicalLicenses, appointmentHistoryLicenses } =
    subTabMedicalLicenses;
  const groupDays = [];

  for (
    let i = 1;
    i <= (appointmentHistoryLicenses?.licensesTypes?.maxDays || 0);
    i++
  )
    groupDays.push({ id: i, label: i });

  return (
    <TabPane tabId={4}>
      <Row form hidden={isPageModalHistory}>
        <Col md="3">
          <Label>Tipo de Licencia:</Label>
          <ReactSelect
            isClearable={!pageEdit}
            options={optionsMedicalLicenses?.filter((item) => item?.maxDays)}
            getOptionValue={(item) => item}
            placeholder="Seleccionar Licencia"
            getOptionLabel={(item) => item.name}
            value={
              isEmpty(appointmentHistoryLicenses?.licensesTypes)
                ? null
                : appointmentHistoryLicenses?.licensesTypes
            }
            onChange={(item) =>
              onChange(
                "tabPrescription",
                {
                  ...appointmentHistoryLicenses,
                  licensesTypes: item,
                  appointmentId,
                  patientId,
                  days: null,
                },
                "subTabMedicalLicenses",
                "appointmentHistoryLicenses"
              )
            }
          />
        </Col>
        <Col md="2">
          <Label>Dias:</Label>
          <ReactSelect
            options={groupDays}
            placeholder="Seleccionar Dia"
            getOptionLabel={(item) => item.label}
            getOptionValue={(item) => item}
            value={
              appointmentHistoryLicenses?.days
                ? { label: appointmentHistoryLicenses?.days }
                : null
            }
            isDisabled={isEmpty(groupDays)}
            onChange={(item) =>
              onChange(
                "tabPrescription",
                { ...appointmentHistoryLicenses, days: item?.label },
                "subTabMedicalLicenses",
                "appointmentHistoryLicenses"
              )
            }
          />
        </Col>
      </Row>
      <Row form className="my-4">
        <Col className="d-flex flex-column">
          <Label>Descripción:</Label>
          <Input
            type="textarea"
            disabled
            value={appointmentHistoryLicenses?.licensesTypes?.description || ""}
          />
        </Col>
      </Row>
      <Row form>
        <Col>
          <Label>Justificación:</Label>
          <Input
            type="textarea"
            disabled={isPageModalHistory}
            onBlur={({ target: { value } }) =>
              onChange(
                "tabPrescription",
                { ...appointmentHistoryLicenses, description: value },
                "subTabMedicalLicenses",
                "appointmentHistoryLicenses"
              )
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") e.currentTarget.blur();
            }}
            defaultValue={appointmentHistoryLicenses?.description || ""}
          />
        </Col>
      </Row>
    </TabPane>
  );
}
